import { PrintPage, ASSETS } from "../components/nk/print/PrintKit";

const CREDENTIALS = [
  "Over 12 years' experience",
  "Creative, one-of-a-kind design",
  "Impeccable hand-finishing",
  "Fast, reliable turnaround",
  "Honest, affordable pricing",
];

export default function PamphletPage() {
  return (
    <PrintPage
      pageW={148}
      pageH={210}
      title="A5 flyer — double-sided"
      subtitle="Two pages (front & back) · print double-sided"
      note="Print double-sided (flip on long edge) on A5, margins None + Background graphics. Exactly two A5 pages."
    >
      {/* ---------- SHEET 1 — Brand & Credentials ---------- */}
      <div className="artboard" data-testid="sheet-front" style={{ width: "148mm", height: "210mm", overflow: "hidden", background: "#FDFBF7" }}>
        <div className="pk-grain h-full w-full relative">
          <div className="relative h-full flex flex-col" style={{ padding: "13mm 12mm" }}>
            <div className="flex items-center gap-4">
              <img src={ASSETS.logoDark} alt="NK Bridal" style={{ height: "18mm", width: "auto" }} className="object-contain" />
              <div className="border-l border-line pl-4">
                <p className="font-serif font-semibold text-ink leading-none" style={{ fontSize: "15pt" }}>NK Bridal</p>
                <p className="text-[9px] uppercase tracking-[0.35em] text-ink mt-1">Australia</p>
              </div>
            </div>
            <h1 className="font-serif font-semibold leading-[0.95] tracking-tight text-ink mt-[12mm]" style={{ fontSize: "29pt" }}>
              A celebrated <span className="italic">Brisbane</span> seamstress — now in Perth
            </h1>
            <div className="mt-[8mm] grid grid-cols-2 gap-[8mm] items-stretch flex-1">
              <div className="relative overflow-hidden border border-line">
                <img src={ASSETS.handStitch} alt="Nancy" className="w-full h-full object-cover object-center" />
              </div>
              <ul className="space-y-[4mm]">
                {CREDENTIALS.map((c) => (
                  <li key={c} className="flex items-start gap-3">
                    <span className="mt-[7px] block w-[10px] h-px bg-champagne shrink-0" />
                    <span className="font-semibold text-ink/95" style={{ fontSize: "11pt", lineHeight: 1.35 }}>{c}</span>
                  </li>
                ))}
                <li className="pt-[3mm] border-t border-line">
                  <span className="font-serif font-semibold italic text-ink" style={{ fontSize: "13pt" }}>Designed &amp; sewn entirely by Nancy.</span>
                </li>
              </ul>
            </div>
            <div className="mt-[6mm] border-t border-ink pt-[5mm] flex items-end justify-between">
              <div>
                <p className="text-[9px] uppercase tracking-[0.35em] text-ink/95 mb-1">Call or message</p>
                <p className="font-serif font-semibold tracking-tight text-ink leading-none" style={{ fontSize: "26pt" }}>0433&nbsp;601&nbsp;060</p>
              </div>
              <div className="text-right">
                <p className="text-[10px] tracking-[0.15em] text-ink/95">nkbridalaustralia.com.au</p>
                <p className="text-[10px] uppercase tracking-[0.25em] text-ink/95 mt-1">FB · Instagram · TikTok</p>
                <p className="text-[10px] tracking-[0.15em] text-ink/95">@nkbridalaustralia</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ---------- SHEET 2 — "My Brides" note ---------- */}
      <div className="artboard" data-testid="sheet-message" style={{ width: "148mm", height: "210mm", overflow: "hidden", background: "#FDFBF7" }}>
        <div className="pk-grain h-full w-full grid grid-cols-5">
          <div className="col-span-2 relative overflow-hidden">
            <img src={ASSETS.couple} alt="bride and groom" className="w-full h-full object-cover object-top" />
            <div className="absolute inset-0 bg-ink/10" />
          </div>
          <div className="col-span-3 flex flex-col" style={{ padding: "13mm 12mm" }}>
            <img src={ASSETS.logoDark} alt="NK Bridal" style={{ height: "16mm", width: "auto" }} className="object-contain self-start" />
            <h2 className="font-serif font-semibold italic text-ink mt-[8mm]" style={{ fontSize: "34pt", lineHeight: 1 }}>My brides,</h2>
            <div className="mt-[7mm] space-y-[4mm] text-ink/95 font-semibold" style={{ fontSize: "11.5pt", lineHeight: 1.5 }}>
              <p>Every gown is unique in its style and fabric — so I warmly recommend booking a <b>free appointment</b>. You'll enjoy a personal experience and be looked after by me, Nancy, myself.</p>
              <p>Or visit our website for the price list and to book your appointment online.</p>
              <p>We are so looking forward to meeting you in our studio soon.</p>
            </div>
            <div className="mt-auto pt-[6mm] border-t border-line">
              <p className="font-serif font-semibold italic text-ink" style={{ fontSize: "16pt" }}>Kind regards,</p>
              <p className="font-serif font-semibold text-ink" style={{ fontSize: "15pt" }}>Nancy &amp; the NK Bridal team</p>
              <p className="mt-[4mm] text-[10px] tracking-[0.15em] text-ink">nkbridalaustralia.com.au · 0433 601 060</p>
            </div>
          </div>
        </div>
      </div>
    </PrintPage>
  );
}
